<div class="t-content" id="transport" [ngStyle]="{ 'margin-bottom': componentResults ? '70px' : '35px' }">
  <div *ngIf="componentResults" class="d-flex justify-content-between align-items-center mb-4 mt-3">
    <div class="d-flex align-items-center" style="gap: 1em">
      <img src="../../../../../assets/img/app/categories-search-box/bus.svg" style="width: 24px" alt="" />
      <h3 class="mb-0 ml-2" style="font-family: &quot;Rubik&quot;, serif">Editar búsqueda de traslado</h3>
    </div>
    <div>
      <button type="button" class="close btn-closed" aria-label="Close" (click)="close()">
        <span aria-hidden="true" style="font-size: 50px !important; font-weight: 100 !important">&times;</span>
      </button>
    </div>
  </div>

  <div
    *ngIf="componentResults && loadingData"
    class="loading-container d-flex flex-column align-items-center justify-content-center py-5 mt-3"
  >
    <div class="logo-loading mb-4">
      <img [src]="agencyImagen" alt="Logo" class="loading-logo animate__animated animate__pulse animate__infinite" />
    </div>

    <div class="text-center animate__animated animate__fadeIn">
      <h4 class="text-muted mb-3">Cargando información, gracias por esperar...</h4>

      <div
        [ngStyle]="{ color: getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
        class="spinner-border"
        role="status"
      ></div>
    </div>
  </div>

  <form *ngIf="!loadingData" (ngSubmit)="_onSubmit(_form, $event)" [formGroup]="_form" novalidate>
    <div class="form-row pt-2 pb-5 position-relative">
      <div class="col-lg-12 col-xg-12 col-md-12 col-sm-12" style="width: 100%; margin-bottom: 10px">
        <button
          type="button"
          (click)="typeSearch('default')"
          style="width: fit-content; border: 0; background-color: transparent; border-radius: 4px"
          [ngStyle]="{
            'background-color': !_form.get('rideHailing').value ? 'black' : 'transparent',
            color: !_form.get('rideHailing').value ? 'white' : 'black'
          }"
        >
          <p class="mb-0 px-2" style="font-family: &quot;Rubik&quot;, sans-serif; font-size: 11px; font-weight: 500">Busqueda Normal</p>
        </button>
        <button
          type="button"
          (click)="typeSearch('realTime')"
          style="width: fit-content; border: 0; background-color: transparent; border-radius: 4px"
          [ngStyle]="{
            'background-color': !_form.get('rideHailing').value ? 'transparent' : 'black',
            color: !_form.get('rideHailing').value ? 'black' : 'white'
          }"
        >
          <p class="mb-0 px-2" style="font-family: &quot;Rubik&quot;, sans-serif; font-size: 11px; font-weight: 500">
            Busqueda Tiempo Real
          </p>
        </button>
      </div>

      <div class="form-group align-items-center m-0 py-0 px-1 col-lg-6 col-xg-6 col-md-12 col-sm-12 scroll position-relative">
        <!-- <ng-container *ngIf="!originInputValue"> -->

        <input
          type="text"
          name="origen"
          matInput
          class="form-control input-search-box input-search-box-truncate"
          style="background-color: white"
          #originInput
          formControlName="firstOrigin"
          placeholder="Origen (Hotel, Aeropuerto, Ciudad)"
          [matAutocomplete]="firstOrigin"
          tooltip="{{ originTooltip }}"
          placement="bottom"
          container="body"
        />
        <mat-autocomplete
          #firstOrigin="matAutocomplete"
          [displayWith]="displayFn"
          (optionSelected)="getLocationsAll($event.option.value, 'origin')"
        >
          <ng-container *ngIf="destinationOptions | async as options">
            <!-- AEROPUERTOS -->
            <ng-container *ngFor="let item of options">
              <ng-container *ngIf="item.type === 'airport'">
                <mat-option disabled style="background-color: #f4f4f4; height: 42px" *ngIf="item.airports && item.airports.length > 0">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex align-items-center" style="gap: 0.25em">
                      <img src="../../../../assets/icons/search-box/avion_gris.svg" style="width: 35px; height: 35px" />
                      <span
                        class="mt-1"
                        style="font-family: &quot;Rubik&quot;, serif; font-size: 13px !important; font-weight: 600 !important"
                        >Aeropuerto</span
                      >
                    </div>
                    <div>
                      <span style="font-family: &quot;Rubik&quot;, serif; font-size: 11px !important; font-weight: 400 !important"
                        >{{ item.airports.length }} resultados</span
                      >
                    </div>
                  </div>
                </mat-option>
                <ng-container *ngFor="let airport of item.airports">
                  <mat-option [value]="{ data: airport, type: item.type }">
                    <div class="d-flex align-items-center" style="gap: 0.75em; margin-left: 9px">
                      <img src="{{ airport?.country_logo }}" style="width: 16px; height: 16px; border-radius: 50%" />
                      <div class="d-flex flex-column">
                          <p
                        class="mb-0"
                        style="font-family: &quot;Rubik&quot;; font-size: 14px !important; font-weight: 400 !important; line-height: 1"
                      >
                        {{ capitalize(airport.name) }},
                        <span
                          class="mb-0"
                          style="font-family: &quot;Rubik&quot;; font-size: 12px !important; line-height: 1; font-weight: 400 !important"
                        >
                          {{ capitalize(airport.country_name) }} <span style="font-weight: 600 !important">({{ airport.iata }}) </span>

                        </span>

                      </p>
                      <span style="font-weight: 400 !important">{{getDistanceAirport(airport, 'origin')}}</span>
                      </div>

                    </div>
                  </mat-option>
                </ng-container>
              </ng-container>
            </ng-container>

            <!-- HOTELES -->
            <ng-container *ngFor="let item of options">
              <ng-container *ngIf="item.type === 'hotel'">
                <mat-option disabled style="background-color: #f4f4f4; height: 42px" *ngIf="item.hotels && item.hotels.length > 0">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex align-items-center" style="gap: 0.25em">
                      <img src="../../../../assets/icons/search-box/hotel_gris.svg" style="width: 35px; height: 35px" />
                      <span
                        class="mt-1"
                        style="font-family: &quot;Rubik&quot;, serif; font-size: 13px !important; font-weight: 600 !important"
                        >Hotel</span
                      >
                    </div>
                    <div>
                      <span style="font-family: &quot;Rubik&quot;, serif; font-size: 11px !important; font-weight: 400 !important"
                        >{{ item.hotels.length }} resultados</span
                      >
                    </div>
                  </div>
                </mat-option>
                <ng-container *ngFor="let hotel of item.hotels">
                  <mat-option [value]="{ data: hotel, type: item.type }">
                    <div class="d-flex align-items-center" style="gap: 0.75em; margin-left: 9px">
                      <img src="{{ hotel?.country_logo }}" style="width: 16px; height: 16px; border-radius: 50%" />
                      <p
                        class="mb-0"
                        style="font-family: &quot;Rubik&quot;; font-size: 14px !important; font-weight: 600 !important; line-height: 1"
                      >
                        {{ capitalize(hotel.name) }},
                        <span
                          class="mb-0"
                          style="font-family: &quot;Rubik&quot;; font-size: 12px !important; line-height: 1; font-weight: 400 !important"
                        >
                          {{ capitalize(hotel.city_name) }}{{ hotel.city_name ? "," : "" }} {{ capitalize(hotel.city_province)
                          }}{{ hotel.city_province ? "," : "" }} {{ capitalize(hotel.country_name) }}</span
                        >
                      </p>
                    </div>
                  </mat-option>
                </ng-container>
              </ng-container>
            </ng-container>

            <!-- UBICACIONES -->
            <ng-container *ngFor="let item of options">
              <ng-container *ngIf="item.type === 'city'">
                <mat-option disabled style="background-color: #f4f4f4; height: 42px" *ngIf="item.cities && item.cities.length > 0">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex align-items-center" style="gap: 0.25em">
                      <img src="../../../../assets/icons/search-box/ubicacion_gris.svg" style="width: 35px; height: 35px" />
                      <span
                        class="mt-1"
                        style="font-family: &quot;Rubik&quot;, serif; font-size: 13px !important; font-weight: 600 !important"
                        >Ubicación</span
                      >
                    </div>
                    <div>
                      <span style="font-family: &quot;Rubik&quot;, serif; font-size: 11px !important; font-weight: 400 !important"
                        >{{ item.cities.length }} resultados</span
                      >
                    </div>
                  </div>
                </mat-option>
                <ng-container *ngFor="let city of item.cities">
                  <mat-option [value]="{ data: city, type: item.type }">
                    <div class="d-flex align-items-center" style="gap: 0.75em; margin-left: 9px">
                      <img src="{{ city?.country_logo }}" style="width: 16px; height: 16px; border-radius: 50%" />
                      <p
                        class="mb-0"
                        style="font-family: &quot;Rubik&quot;; font-size: 14px !important; font-weight: 600 !important; line-height: 1"
                      >
                        {{ capitalize(city?.city_name) || capitalize(city?.main_text) }},
                        <span
                          class="mb-0"
                          style="font-family: &quot;Rubik&quot;; font-size: 12px !important; line-height: 1; font-weight: 400 !important"
                          >{{ capitalize(city?.city_province) }}{{ city?.city_province ? "," : "" }} {{ capitalize(city.country_name) }}
                          {{ city?.secondary_text }}</span
                        >
                      </p>
                    </div>
                  </mat-option>
                </ng-container>
              </ng-container>
            </ng-container>

            <!-- PUERTOS -->
            <ng-container *ngFor="let item of options">
              <ng-container *ngIf="item.type === 'port'">
                <mat-option disabled style="background-color: #f4f4f4; height: 42px" *ngIf="item.ports && item.ports.length > 0">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex align-items-center ml-1" style="gap: 0.25em">
                      <img src="../../../../assets/icons/search-box/puerto.svg" style="width: 20px; height: 20px" />
                      <span
                        class="mt-1 ml-2"
                        style="font-family: &quot;Rubik&quot;, serif; font-size: 13px !important; font-weight: 600 !important"
                        >Puerto</span
                      >
                    </div>
                    <div>
                      <span style="font-family: &quot;Rubik&quot;, serif; font-size: 11px !important; font-weight: 400 !important"
                        >{{ item.ports.length }} resultados</span
                      >
                    </div>
                  </div>
                </mat-option>
                <ng-container *ngFor="let port of item.ports">
                  <mat-option [value]="{ data: port, type: item.type }">
                    <div class="d-flex align-items-center" style="gap: 0.75em; margin-left: 9px">
                      <img src="{{ port?.country_logo }}" style="width: 16px; height: 16px; border-radius: 50%" />
                      <p
                        class="mb-0"
                        style="font-family: &quot;Rubik&quot;; font-size: 14px !important; font-weight: 600 !important; line-height: 1"
                      >
                        {{ capitalize(port.name) }},
                        <span
                          class="mb-0"
                          style="font-family: &quot;Rubik&quot;; font-size: 12px !important; line-height: 1; font-weight: 400 !important"
                        >
                          {{ capitalize(port.city_name) }}, {{ capitalize(port.country_name) }}
                        </span>
                      </p>
                    </div>
                  </mat-option>
                </ng-container>
              </ng-container>
            </ng-container>

            <!-- TRENES -->
            <ng-container *ngFor="let item of options">
              <ng-container *ngIf="item.type === 'train'">
                <mat-option disabled style="background-color: #f4f4f4; height: 42px" *ngIf="item.trains && item.trains.length > 0">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex align-items-center ml-1" style="gap: 0.25em">
                      <img src="../../../../assets/icons/search-box/tren.svg" style="width: 20px; height: 20px" />
                      <span
                        class="mt-1 ml-2"
                        style="font-family: &quot;Rubik&quot;, serif; font-size: 13px !important; font-weight: 600 !important"
                        >Tren</span
                      >
                    </div>
                    <div>
                      <span style="font-family: &quot;Rubik&quot;, serif; font-size: 11px !important; font-weight: 400 !important"
                        >{{ item.trains.length }} resultados</span
                      >
                    </div>
                  </div>
                </mat-option>
                <ng-container *ngFor="let train of item.trains">
                  <mat-option [value]="{ data: train, type: item.type }">
                    <div class="d-flex align-items-center" style="gap: 0.75em; margin-left: 9px">
                      <img src="{{ train?.country_logo }}" style="width: 16px; height: 16px; border-radius: 50%" />
                      <p
                        class="mb-0"
                        style="font-family: &quot;Rubik&quot;; font-size: 14px !important; font-weight: 600 !important; line-height: 1"
                      >
                        {{ capitalize(train.name) }},
                        <span
                          class="mb-0"
                          style="font-family: &quot;Rubik&quot;; font-size: 12px !important; line-height: 1; font-weight: 400 !important"
                        >
                          {{ capitalize(train.city_name) }}, {{ capitalize(train.country_name) }}
                        </span>
                      </p>
                    </div>
                  </mat-option>
                </ng-container>
              </ng-container>
            </ng-container>

            <!-- AUTOBUSES -->
            <ng-container *ngFor="let item of options">
              <ng-container *ngIf="item.type === 'bus'">
                <mat-option disabled style="background-color: #f4f4f4; height: 42px" *ngIf="item.buses && item.buses.length > 0">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex align-items-center ml-1" style="gap: 0.25em">
                      <img src="../../../../assets/icons/search-box/bus.svg" style="width: 20px; height: 20px" />
                      <span
                        class="mt-1 ml-2"
                        style="font-family: &quot;Rubik&quot;, serif; font-size: 13px !important; font-weight: 600 !important"
                        >Bus</span
                      >
                    </div>
                    <div>
                      <span style="font-family: &quot;Rubik&quot;, serif; font-size: 11px !important; font-weight: 400 !important"
                        >{{ item.buses.length }} resultados</span
                      >
                    </div>
                  </div>
                </mat-option>
                <ng-container *ngFor="let bus of item.buses">
                  <mat-option [value]="{ data: bus, type: item.type }">
                    <div style="margin-left: 2.4em">
                      <p
                        class="mb-0"
                        style="font-family: &quot;Rubik&quot;; font-size: 14px !important; font-weight: 600 !important; line-height: 1"
                      >
                        {{ capitalize(bus.name) }},
                        <span
                          class="mb-0"
                          style="font-family: &quot;Rubik&quot;; font-size: 12px !important; line-height: 1; font-weight: 400 !important"
                        >
                          {{ capitalize(bus.city_name) }}, {{ capitalize(bus.country_name) }}
                        </span>
                      </p>
                    </div>
                  </mat-option>
                </ng-container>
              </ng-container>
            </ng-container>

            <!-- RESTAURANTE -->
            <ng-container *ngFor="let item of options">
              <ng-container *ngIf="item.type === 'restaurant'">
                <mat-option
                  disabled
                  style="background-color: #f4f4f4; height: 42px"
                  *ngIf="item.restaurants && item.restaurants.length > 0"
                >
                  <div class="d-flex justify-content-between">
                    <div class="d-flex align-items-center ml-1" style="gap: 0.25em">
                      <img src="../../../../assets/icons/search-box/restaurante.svg" style="width: 20px; height: 20px" />
                      <span
                        class="mt-1 ml-2"
                        style="font-family: &quot;Rubik&quot;, serif; font-size: 13px !important; font-weight: 600 !important"
                        >Restaurante</span
                      >
                    </div>
                    <div>
                      <span style="font-family: &quot;Rubik&quot;, serif; font-size: 11px !important; font-weight: 400 !important"
                        >{{ item.restaurants.length }} resultados</span
                      >
                    </div>
                  </div>
                </mat-option>
                <ng-container *ngFor="let restaurant of item.restaurants">
                  <mat-option [value]="{ data: restaurant, type: item.type }">
                    <div style="margin-left: 2.4em">
                      <p
                        class="mb-0"
                        style="font-family: &quot;Rubik&quot;; font-size: 14px !important; font-weight: 600 !important; line-height: 1"
                      >
                        {{ capitalize(restaurant.name) }},
                        <span
                          class="mb-0"
                          style="font-family: &quot;Rubik&quot;; font-size: 12px !important; line-height: 1; font-weight: 400 !important"
                        >
                          {{ capitalize(restaurant.city_name) }}, {{ capitalize(restaurant.country_name) }}
                        </span>
                      </p>
                    </div>
                  </mat-option>
                </ng-container>
              </ng-container>
            </ng-container>

            <!-- ATRACCIONES -->
            <ng-container *ngFor="let item of options">
              <ng-container *ngIf="item.type === 'attraction'">
                <mat-option
                  disabled
                  style="background-color: #f4f4f4; height: 42px"
                  *ngIf="item.attractions && item.attractions.length > 0"
                >
                  <div class="d-flex justify-content-between">
                    <div class="d-flex align-items-center ml-1" style="gap: 0.25em">
                      <img src="../../../../assets/icons/search-box/atracciones.svg" style="width: 20px; height: 20px" />
                      <span
                        class="mt-1 ml-2"
                        style="font-family: &quot;Rubik&quot;, serif; font-size: 13px !important; font-weight: 600 !important"
                        >Atracciones</span
                      >
                    </div>
                    <div>
                      <span style="font-family: &quot;Rubik&quot;, serif; font-size: 11px !important; font-weight: 400 !important"
                        >{{ item.attractions.length }} resultados</span
                      >
                    </div>
                  </div>
                </mat-option>
                <ng-container *ngFor="let attraction of item.attractions">
                  <mat-option [value]="{ data: attraction, type: item.type }">
                    <div style="margin-left: 2.4em">
                      <p
                        class="mb-0"
                        style="font-family: &quot;Rubik&quot;; font-size: 14px !important; font-weight: 600 !important; line-height: 1"
                      >
                        {{ capitalize(attraction.name) }},
                        <span
                          class="mb-0"
                          style="font-family: &quot;Rubik&quot;; font-size: 12px !important; line-height: 1; font-weight: 400 !important"
                        >
                          {{ capitalize(attraction.city_name) }}, {{ capitalize(attraction.country_name) }}
                        </span>
                      </p>
                    </div>
                  </mat-option>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </mat-autocomplete>
        <!-- </ng-container> -->

        <!-- <ng-container *ngIf="originInputValue">
            <span class="container-input-icon-cancel" style="position:relative">
              <input type="text"
              name="destino"
              matInput
              class="form-control input-search-box"
              style="background-color: white;"
              #destination
              [value]="originInputValue"
              placeholder="Origen (Hotel, Aeropuerto, Ciudad)"
              readonly

              >
              <span class="square-class-secondArrival">
                <div class="container-square-secondArrival">
                  <i class="bi bi-x x-icon-cancel"
                      (mouseenter)="isHoveredCancelDate = true" (mouseleave)="isHoveredCancelDate = false"
                      tooltip="Eliminar destino"
                      placement="bottom"
                      (click)="resetInputsOriginDestination('origin')"
                      ></i>
                </div>
              </span>
            </span>
          </ng-container> -->

        <div class="d-flex justify-content-between align-items-center">
          <div>
            <p
              *ngIf="_form.get('firstOrigin').touched && mesaggeErrorVisibleOrigin"
              style="font-family: &quot;Poppins&quot;; font-size: 12px; margin-bottom: 0px; color: red"
            >
              Debe seleccionar un lugar de origen
            </p>
          </div>
          <div class="d-flex justify-content-between mt-2 px-2" style="gap: 0.5em">
            <label class="switch" style="position: relative">
              <input
                type="checkbox"
                [checked]="pointMessageOrigin === 'Domicilio'"
                (change)="changeTypeSearch($event.target.checked, 'origin')"
              />
              <span
                #sliderElement
                class="slider"
                style="border: 0.5px solid #dbdbdb"
                [ngStyle]="{
                  'background-color': sliderBackgroundColor
                }"
              ></span>
              <p
                class="text-option mb-0"
                style="font-size: 11px !important; position: absolute; top: 18%"
                [ngStyle]="{ left: pointMessageOrigin === 'Traslado' ? '33%' : '16%' }"
              >
                {{ pointMessageOrigin }}
              </p>
            </label>

            <!-- <p
                              class="text-option mb-0"
                              style="font-size: 12px !important;"

                              [ngStyle]="
                                          {
                                            'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1
                                          }
                                        "

                              > Traslado
                    </p>
                   <label class="switch">
                      <input type="checkbox"
                          [checked]="searchPointToPoint"
                          (change)="changeTypeSearch($event.target.checked, 'origin')">
                      <span class="slider"></span>
                    </label>
                    <p
                              class="text-option mb-0"
                              style="font-size: 12px !important;"

                              [ngStyle]="
                                          {
                                            'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1
                                          }
                                        "

                              > Dirección
                    </p> -->
          </div>
        </div>
      </div>

      <!-- Botón de intercambio -->
      <div class="container-button-transfer-destination">
        <div class="position-relative group-button-transfer-destination">
          <i
            role="button"
            tabindex="0"
            class="bi bi-circle-fill circle-btn"
            [ngStyle]="{
              'text-shadow': isHovered ? '0px 0px 5px ' + getClientsSettingAppBooking?.clients_setting_global?.color_main_1 : ''
            }"
            (mouseenter)="isHovered = true"
            (mouseleave)="isHovered = false"
            (click)="swapLocations()"
          ></i>
          <i
            role="button"
            tabindex="0"
            class="bi bi-arrow-left-right swap-btn"
            (click)="swapLocations()"
            [ngStyle]="{
              color: isHovered ? getClientsSettingAppBooking?.clients_setting_global?.color_main_1 : ''
            }"
            (mouseenter)="isHovered = true"
            (mouseleave)="isHovered = false"
          ></i>
        </div>
      </div>

      <div class="form-group align-items-center m-0 py-0 px-1 col-lg-6 col-xg-6 col-md-12 col-sm-12 scroll position-relative">
        <input
          type="text"
          name="destino"
          matInput
          class="form-control input-search-box input-search-box-truncate"
          style="background-color: white"
          #destination
          formControlName="firstDestination"
          placeholder="Destino (Hotel, Aeropuerto, Ciudad)"
          [matAutocomplete]="firstDestination"
          tooltip="{{ destinationTooltip }}"
          placement="bottom"
          container="body"
        />
        <mat-autocomplete
          #firstDestination="matAutocomplete"
          [displayWith]="displayFn"
          (optionSelected)="getLocationsAll($event.option.value, 'destination')"
        >
          <ng-container *ngIf="destinationOptions_ | async as options">
            <!-- AEROPUERTOS -->
            <ng-container *ngFor="let item of options">
              <ng-container *ngIf="item.type === 'airport'">
                <mat-option disabled style="background-color: #f4f4f4; height: 42px" *ngIf="item.airports && item.airports.length > 0">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex align-items-center" style="gap: 0.25em">
                      <img src="../../../../assets/icons/search-box/avion_gris.svg" style="width: 35px; height: 35px" />
                      <span
                        class="mt-1"
                        style="font-family: &quot;Rubik&quot;, serif; font-size: 13px !important; font-weight: 600 !important"
                        >Aeropuerto</span
                      >
                    </div>
                    <div>
                      <span style="font-family: &quot;Rubik&quot;, serif; font-size: 11px !important; font-weight: 400 !important"
                        >{{ item.airports.length }} resultados</span
                      >
                    </div>
                  </div>
                </mat-option>
                <ng-container *ngFor="let airport of item.airports">
                  <mat-option [value]="{ data: airport, type: item.type }">
                    <div class="d-flex align-items-center" style="gap: 0.75em; margin-left: 9px">
                      <img src="{{ airport?.country_logo }}" style="width: 16px; height: 16px; border-radius: 50%" />
                      <div class="d-flex flex-column">
                      <p
                        class="mb-0"
                        style="font-family: &quot;Rubik&quot;; font-size: 14px !important; font-weight: 400 !important; line-height: 1"
                      >
                        {{ capitalize(airport.name) }},
                        <span
                          class="mb-0"
                          style="font-family: &quot;Rubik&quot;; font-size: 12px !important; line-height: 1; font-weight: 400 !important"
                        >
                          {{ capitalize(airport.country_name) }} <span style="font-weight: 600 !important">({{ airport.iata }}) </span>

                        </span>

                      </p>
                      <span style="font-weight: 400 !important">{{getDistanceAirport(airport, 'destination')}}</span>
                      </div>
                    </div>
                  </mat-option>
                </ng-container>
              </ng-container>
            </ng-container>

            <!-- HOTELES -->
            <ng-container *ngFor="let item of options">
              <ng-container *ngIf="item.type === 'hotel'">
                <mat-option disabled style="background-color: #f4f4f4; height: 42px" *ngIf="item.hotels && item.hotels.length > 0">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex align-items-center" style="gap: 0.25em">
                      <img src="../../../../assets/icons/search-box/hotel_gris.svg" style="width: 35px; height: 35px" />
                      <span
                        class="mt-1"
                        style="font-family: &quot;Rubik&quot;, serif; font-size: 13px !important; font-weight: 600 !important"
                        >Hotel</span
                      >
                    </div>
                    <div>
                      <span style="font-family: &quot;Rubik&quot;, serif; font-size: 11px !important; font-weight: 400 !important"
                        >{{ item.hotels.length }} resultados</span
                      >
                    </div>
                  </div>
                </mat-option>
                <ng-container *ngFor="let hotel of item.hotels">
                  <mat-option [value]="{ data: hotel, type: item.type }">
                    <div class="d-flex align-items-center" style="gap: 0.75em; margin-left: 9px">
                      <img src="{{ hotel?.country_logo }}" style="width: 16px; height: 16px; border-radius: 50%" />
                      <p
                        class="mb-0"
                        style="font-family: &quot;Rubik&quot;; font-size: 14px !important; font-weight: 600 !important; line-height: 1"
                      >
                        {{ capitalize(hotel.name) }},
                        <span
                          class="mb-0"
                          style="font-family: &quot;Rubik&quot;; font-size: 12px !important; line-height: 1; font-weight: 400 !important"
                        >
                          {{ capitalize(hotel.city_name) }}{{ hotel.city_name ? "," : "" }} {{ capitalize(hotel.city_province)
                          }}{{ hotel.city_province ? "," : "" }} {{ capitalize(hotel.country_name) }}</span
                        >
                      </p>
                    </div>
                  </mat-option>
                </ng-container>
              </ng-container>
            </ng-container>

            <!-- UBICACIONES -->
            <ng-container *ngFor="let item of options">
              <ng-container *ngIf="item.type === 'city'">
                <mat-option disabled style="background-color: #f4f4f4; height: 42px" *ngIf="item.cities && item.cities.length > 0">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex align-items-center" style="gap: 0.25em">
                      <img src="../../../../assets/icons/search-box/ubicacion_gris.svg" style="width: 35px; height: 35px" />
                      <span
                        class="mt-1"
                        style="font-family: &quot;Rubik&quot;, serif; font-size: 13px !important; font-weight: 600 !important"
                        >Ubicación</span
                      >
                    </div>
                    <div>
                      <span style="font-family: &quot;Rubik&quot;, serif; font-size: 11px !important; font-weight: 400 !important"
                        >{{ item.cities.length }} resultados</span
                      >
                    </div>
                  </div>
                </mat-option>
                <ng-container *ngFor="let city of item.cities">
                  <mat-option [value]="{ data: city, type: item.type }">
                    <div class="d-flex align-items-center" style="gap: 0.75em; margin-left: 9px">
                      <img src="{{ city?.country_logo }}" style="width: 16px; height: 16px; border-radius: 50%" />
                      <p
                        class="mb-0"
                        style="font-family: &quot;Rubik&quot;; font-size: 14px !important; font-weight: 600 !important; line-height: 1"
                      >
                        {{ capitalize(city?.city_name) || capitalize(city?.main_text) }},
                        <span
                          class="mb-0"
                          style="font-family: &quot;Rubik&quot;; font-size: 12px !important; line-height: 1; font-weight: 400 !important"
                          >{{ capitalize(city?.city_province) }}{{ city?.city_province ? "," : "" }} {{ capitalize(city.country_name) }}
                          {{ city?.secondary_text }}</span
                        >
                      </p>
                    </div>
                  </mat-option>
                </ng-container>
              </ng-container>
            </ng-container>

            <!-- PUERTOS -->
            <ng-container *ngFor="let item of options">
              <ng-container *ngIf="item.type === 'port'">
                <mat-option disabled style="background-color: #f4f4f4; height: 42px" *ngIf="item.ports && item.ports.length > 0">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex align-items-center ml-1" style="gap: 0.25em">
                      <img src="../../../../assets/icons/search-box/puerto.svg" style="width: 20px; height: 20px" />
                      <span
                        class="mt-1 ml-2"
                        style="font-family: &quot;Rubik&quot;, serif; font-size: 13px !important; font-weight: 600 !important"
                        >Puerto</span
                      >
                    </div>
                    <div>
                      <span style="font-family: &quot;Rubik&quot;, serif; font-size: 11px !important; font-weight: 400 !important"
                        >{{ item.ports.length }} resultados</span
                      >
                    </div>
                  </div>
                </mat-option>
                <ng-container *ngFor="let port of item.ports">
                  <mat-option [value]="{ data: port, type: item.type }">
                    <div class="d-flex align-items-center" style="gap: 0.75em; margin-left: 9px">
                      <img src="{{ port?.country_logo }}" style="width: 16px; height: 16px; border-radius: 50%" />
                      <p
                        class="mb-0"
                        style="font-family: &quot;Rubik&quot;; font-size: 14px !important; font-weight: 600 !important; line-height: 1"
                      >
                        {{ capitalize(port.name) }},
                        <span
                          class="mb-0"
                          style="font-family: &quot;Rubik&quot;; font-size: 12px !important; line-height: 1; font-weight: 400 !important"
                        >
                          {{ capitalize(port.city_name) }}, {{ capitalize(port.country_name) }}
                        </span>
                      </p>
                    </div>
                  </mat-option>
                </ng-container>
              </ng-container>
            </ng-container>

            <!-- TRENES -->
            <ng-container *ngFor="let item of options">
              <ng-container *ngIf="item.type === 'train'">
                <mat-option disabled style="background-color: #f4f4f4; height: 42px" *ngIf="item.trains && item.trains.length > 0">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex align-items-center ml-1" style="gap: 0.25em">
                      <img src="../../../../assets/icons/search-box/tren.svg" style="width: 20px; height: 20px" />
                      <span
                        class="mt-1 ml-2"
                        style="font-family: &quot;Rubik&quot;, serif; font-size: 13px !important; font-weight: 600 !important"
                        >Tren</span
                      >
                    </div>
                    <div>
                      <span style="font-family: &quot;Rubik&quot;, serif; font-size: 11px !important; font-weight: 400 !important"
                        >{{ item.trains.length }} resultados</span
                      >
                    </div>
                  </div>
                </mat-option>
                <ng-container *ngFor="let train of item.trains">
                  <mat-option [value]="{ data: train, type: item.type }">
                    <div class="d-flex align-items-center" style="gap: 0.75em; margin-left: 9px">
                      <img src="{{ train?.country_logo }}" style="width: 16px; height: 16px; border-radius: 50%" />
                      <p
                        class="mb-0"
                        style="font-family: &quot;Rubik&quot;; font-size: 14px !important; font-weight: 600 !important; line-height: 1"
                      >
                        {{ capitalize(train.name) }},
                        <span
                          class="mb-0"
                          style="font-family: &quot;Rubik&quot;; font-size: 12px !important; line-height: 1; font-weight: 400 !important"
                        >
                          {{ capitalize(train.city_name) }}, {{ capitalize(train.country_name) }}
                        </span>
                      </p>
                    </div>
                  </mat-option>
                </ng-container>
              </ng-container>
            </ng-container>

            <!-- AUTOBUSES -->
            <ng-container *ngFor="let item of options">
              <ng-container *ngIf="item.type === 'bus'">
                <mat-option disabled style="background-color: #f4f4f4; height: 42px" *ngIf="item.buses && item.buses.length > 0">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex align-items-center ml-1" style="gap: 0.25em">
                      <img src="../../../../assets/icons/search-box/bus.svg" style="width: 20px; height: 20px" />
                      <span
                        class="mt-1 ml-2"
                        style="font-family: &quot;Rubik&quot;, serif; font-size: 13px !important; font-weight: 600 !important"
                        >Bus</span
                      >
                    </div>
                    <div>
                      <span style="font-family: &quot;Rubik&quot;, serif; font-size: 11px !important; font-weight: 400 !important"
                        >{{ item.buses.length }} resultados</span
                      >
                    </div>
                  </div>
                </mat-option>
                <ng-container *ngFor="let bus of item.buses">
                  <mat-option [value]="{ data: bus, type: item.type }">
                    <div style="margin-left: 2.4em">
                      <p
                        class="mb-0"
                        style="font-family: &quot;Rubik&quot;; font-size: 14px !important; font-weight: 600 !important; line-height: 1"
                      >
                        {{ capitalize(bus.name) }},
                        <span
                          class="mb-0"
                          style="font-family: &quot;Rubik&quot;; font-size: 12px !important; line-height: 1; font-weight: 400 !important"
                        >
                          {{ capitalize(bus.city_name) }}, {{ capitalize(bus.country_name) }}
                        </span>
                      </p>
                    </div>
                  </mat-option>
                </ng-container>
              </ng-container>
            </ng-container>

            <!-- RESTAURANTE -->
            <ng-container *ngFor="let item of options">
              <ng-container *ngIf="item.type === 'restaurant'">
                <mat-option
                  disabled
                  style="background-color: #f4f4f4; height: 42px"
                  *ngIf="item.restaurants && item.restaurants.length > 0"
                >
                  <div class="d-flex justify-content-between">
                    <div class="d-flex align-items-center ml-1" style="gap: 0.25em">
                      <img src="../../../../assets/icons/search-box/restaurante.svg" style="width: 20px; height: 20px" />
                      <span
                        class="mt-1 ml-2"
                        style="font-family: &quot;Rubik&quot;, serif; font-size: 13px !important; font-weight: 600 !important"
                        >Restaurante</span
                      >
                    </div>
                    <div>
                      <span style="font-family: &quot;Rubik&quot;, serif; font-size: 11px !important; font-weight: 400 !important"
                        >{{ item.restaurants.length }} resultados</span
                      >
                    </div>
                  </div>
                </mat-option>
                <ng-container *ngFor="let restaurant of item.restaurants">
                  <mat-option [value]="{ data: restaurant, type: item.type }">
                    <div style="margin-left: 2.4em">
                      <p
                        class="mb-0"
                        style="font-family: &quot;Rubik&quot;; font-size: 14px !important; font-weight: 600 !important; line-height: 1"
                      >
                        {{ capitalize(restaurant.name) }},
                        <span
                          class="mb-0"
                          style="font-family: &quot;Rubik&quot;; font-size: 12px !important; line-height: 1; font-weight: 400 !important"
                        >
                          {{ capitalize(restaurant.city_name) }}, {{ capitalize(restaurant.country_name) }}
                        </span>
                      </p>
                    </div>
                  </mat-option>
                </ng-container>
              </ng-container>
            </ng-container>

            <!-- ATRACCIONES -->
            <ng-container *ngFor="let item of options">
              <ng-container *ngIf="item.type === 'attraction'">
                <mat-option
                  disabled
                  style="background-color: #f4f4f4; height: 42px"
                  *ngIf="item.attractions && item.attractions.length > 0"
                >
                  <div class="d-flex justify-content-between">
                    <div class="d-flex align-items-center ml-1" style="gap: 0.25em">
                      <img src="../../../../assets/icons/search-box/atracciones.svg" style="width: 20px; height: 20px" />
                      <span
                        class="mt-1 ml-2"
                        style="font-family: &quot;Rubik&quot;, serif; font-size: 13px !important; font-weight: 600 !important"
                        >Atracciones</span
                      >
                    </div>
                    <div>
                      <span style="font-family: &quot;Rubik&quot;, serif; font-size: 11px !important; font-weight: 400 !important"
                        >{{ item.attractions.length }} resultados</span
                      >
                    </div>
                  </div>
                </mat-option>
                <ng-container *ngFor="let attraction of item.attractions">
                  <mat-option [value]="{ data: attraction, type: item.type }">
                    <div style="margin-left: 2.4em">
                      <p
                        class="mb-0"
                        style="font-family: &quot;Rubik&quot;; font-size: 14px !important; font-weight: 600 !important; line-height: 1"
                      >
                        {{ capitalize(attraction.name) }},
                        <span
                          class="mb-0"
                          style="font-family: &quot;Rubik&quot;; font-size: 12px !important; line-height: 1; font-weight: 400 !important"
                        >
                          {{ capitalize(attraction.city_name) }}, {{ capitalize(attraction.country_name) }}
                        </span>
                      </p>
                    </div>
                  </mat-option>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </mat-autocomplete>

        <!-- <ng-container *ngIf="destinationInputValue">
            <span class="container-input-icon-cancel" style="position:relative">
              <input type="text"
              name="destino"
              matInput
              class="form-control input-search-box"
              style="background-color: white;"
              #destination
              [value]="destinationInputValue"
              placeholder="Origen (Hotel, Aeropuerto, Ciudad)"
              readonly

              >
              <span class="square-class-secondArrival">
                <div class="container-square-secondArrival">
                  <i class="bi bi-x x-icon-cancel"
                      (mouseenter)="isHoveredCancelDate = true" (mouseleave)="isHoveredCancelDate = false"
                      tooltip="Eliminar destino"
                      placement="bottom"
                      (click)="resetInputsOriginDestination('destination')"
                      ></i>
                </div>
              </span>
            </span>
          </ng-container> -->

        <div class="d-flex justify-content-between align-items-center">
          <div>
            <p
              *ngIf="_form.get('firstDestination').touched && mesaggeErrorVisibleDestination"
              style="font-family: &quot;Poppins&quot;; font-size: 12px; margin-bottom: 0px; color: red"
            >
              Debe seleccionar un lugar de destino
            </p>
          </div>
          <div class="d-flex justify-content-between mt-2 px-2" style="gap: 0.5em">
            <!-- <p
                              class="text-option mb-0"
                              style="font-size: 12px !important;"

                              [ngStyle]="
                                          {
                                            'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1
                                          }
                                        "

                              > Traslado
                    </p> -->
            <label class="switch" style="position: relative">
              <input
                type="checkbox"
                [checked]="pointMessageDestination === 'Domicilio'"
                (change)="changeTypeSearch($event.target.checked, 'destination')"
              />
              <span
                #sliderDestinationElement
                class="slider-s2"
                style="border: 0.5px solid #dbdbdb"
                [ngStyle]="{
                  'background-color': sliderDestinationBackgroundColor
                }"
              ></span>
              <p
                class="text-option mb-0"
                style="font-size: 11px !important; position: absolute; top: 18%"
                [ngStyle]="{ left: pointMessageDestination === 'Traslado' ? '33%' : '16%' }"
              >
                {{ pointMessageDestination }}
              </p>
            </label>
            <!-- <p
                              class="text-option mb-0"
                              style="font-size: 12px !important;"

                              [ngStyle]="
                                          {
                                            'color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1
                                          }
                                        "

                              > Dirección
                    </p> -->
          </div>
        </div>
      </div>

      <div class="form-group m-0 px-1 pb-1 pt-0 col-xg-4 col-lg-2 col-md-12 col-sm-12" style="position: relative">
        <!-- <label for="passengers">&nbsp;</label> -->
        <button
          #triggerButton
          type="button"
          class="form-control btn-usb-rp d-flex align-items-center justify-content-between element-config-passenger"
          (click)="_openModal(); expandedConfigPassenger()"
          [attr.aria-expanded]="!isCollapsed"
          aria-controls="false"
        >
          <p class="p-0 m-0 align-self-center align-middle font-poppins text-passenger-input">{{ passengers }}</p>

          <img width="10" height="10" src="../../../../../assets/img/app/little-icons/arrow-down-black.svg" />
        </button>

        <span class="help-block text-danger" *ngIf="_close && isCollapsed && _form.value['firstqtyAdults'] == 0"
          >Al menos selecciona 1 adulto.</span
        >
        <div
          (collapsed)="clickOutside($event)"
          (expanded)="($event)"
          [collapse]="!isCollapsed || _close"
          (click)="_over()"
          class="config-passenger"
        >
          <div class="row">
            <div style="position: relative; width: 100%">
              <div
                #cardSelectorRoom
                id="cardSelectorRoom"
                class="card py-4 px-4 scrollable-card-container"
                style="width: auto !important; min-width: 100%"
                [ngStyle]="{ top: componentResults ? '-170px' : '0' }"
              >
                <div class="room-content">
                  <div class="d-flex flex-row col-12 align-items-center justify-content-between p-2">
                    <div class="d-flex flex-column">
                      <div class="d-flex flex-row align-items-start justify-content-between p-0 pb-3">
                        <div class="d-flex flex-column">
                          <div class="d-flex flex-column">
                            <div style="line-height: 1">&nbsp;</div>
                            <div style="line-height: 1">&nbsp;</div>
                          </div>
                          <div
                            class="mr-2"
                            style="padding: 28px 0 0 0; font-family: &quot;Rubik&quot;; font-size: 14px; font-weight: 500; width: 70px"
                          >
                            Pasajeros
                          </div>
                        </div>
                        <div class="d-flex flex-column align-items-center p-0 m-0 mr-2 ml-3">
                          <div class="d-flex flex-column align-items-start mb-3">
                            <label
                              class="mb-0"
                              style="
                                font-family: &quot;Rubik&quot; !important;
                                font-size: 14px !important;
                                font-weight: 600 !important;
                                line-height: 1;
                              "
                              for="adults"
                              >Adultos</label
                            >
                            <p
                              class="mb-0"
                              style="
                                font-family: &quot;Rubik&quot; !important;
                                font-size: 11px !important;
                                font-weight: 400 !important;
                                line-height: 1;
                              "
                            >
                              + de 18 años
                            </p>
                          </div>
                          <div class="input-group justify-content-end" style="max-width: 200px; width: 100%; min-width: 91px">
                            <button
                              type="button"
                              class="pr-2"
                              style="border: none; background-color: transparent"
                              (click)="decrementPassengerAdult($event)"
                              [disabled]="getPassengerCountAdult() <= 1"
                            >
                              <p class="mb-0" style="font-size: 20px; font-weight: 700 !important">-</p>
                            </button>

                            <input
                              type="number"
                              class="form-control text-center"
                              style="border-radius: 8px; max-width: 45px; padding: 0 !important"
                              [value]="getPassengerCountAdult()"
                              [min]="1"
                              [max]="MAX_ADULTS"
                              (change)="validatePassengerInput($event)"
                              (keydown)="handleAdultInput($event)"
                              (blur)="handleAdultBlur($event)"
                              (click)="preventModalClose($event)"
                              name="adults"
                            />

                            <button
                              type="button"
                              class="pl-2"
                              style="border: none; background-color: transparent"
                              (click)="incrementPassengerAdult($event)"
                              [disabled]="getPassengerCountAdult() >= MAX_ADULTS"
                            >
                              <p class="mb-0" style="font-size: 20px; font-weight: 700 !important">+</p>
                            </button>
                          </div>
                        </div>
                        <div class="d-flex flex-column align-items-center p-0 m-0 mr-3 ml-2">
                          <div class="container-label d-flex mb-3">
                            <div class="d-flex flex-column align-items-start">
                              <div class="d-flex" style="line-height: 1">
                                <label
                                  class="mb-0"
                                  style="
                                    font-family: &quot;Rubik&quot; !important;
                                    font-size: 14px !important;
                                    font-weight: 600 !important;
                                    line-height: 1;
                                  "
                                  for="childs"
                                  >Niños</label
                                >
                                <div class="info-tool d-flex flex-column position-relative">
                                  <img #iconInfo src="../../../../../assets/icons/search-box/Informativo-01.svg" width="13px" alt="" />
                                  <span class="tooltip-info">Los bebes (0 - 2 años sin cumplir) deben indicarse como niños</span>
                                </div>
                              </div>
                              <p
                                class="mb-0"
                                style="
                                  font-family: &quot;Rubik&quot; !important;
                                  font-size: 11px !important;
                                  font-weight: 400 !important;
                                  line-height: 1;
                                "
                              >
                                - de 18 años
                              </p>
                            </div>
                          </div>
                          <div class="input-group justify-content-end" style="max-width: 200px; width: 100%; min-width: 91px">
                            <button
                              type="button"
                              style="border: none; background-color: transparent"
                              class="pr-2"
                              (click)="decrementPassengerChildren($event)"
                              [disabled]="getPassengerCountChildren() <= 0"
                            >
                              <p class="mb-0" style="font-size: 20px; font-weight: 700 !important">-</p>
                            </button>

                            <input
                              type="number"
                              class="form-control text-center"
                              style="border-radius: 8px; max-width: 45px; padding: 0 !important"
                              [value]="getPassengerCountChildren()"
                              [min]="0"
                              [max]="10"
                              (change)="validatePassengerInput($event)"
                              (keydown)="handleChildrenInput($event)"
                              (blur)="handleChildrenBlur($event)"
                              (click)="preventModalClose($event)"
                              name="children"
                            />

                            <button
                              type="button"
                              style="border: none; background-color: transparent"
                              class="pl-2"
                              (click)="incrementPassengerChildren($event)"
                              [disabled]="getPassengerCountChildren() >= 10"
                            >
                              <p class="mb-0" style="font-size: 20px; font-weight: 700 !important">+</p>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        *ngIf="formArray(_form, 'firstchildsage').length > 0"
                        class="d-flex flex-column p-4 m-0"
                        style="border-radius: 10px; background-color: #f4f4f4"
                      >
                        <div class="d-flex flex-column align-items-start mb-3 ml-1">
                          <label
                            class="mb-0"
                            style="
                              font-family: &quot;Rubik&quot; !important;
                              font-size: 14px !important;
                              font-weight: 600 !important;
                              line-height: 1;
                              text-wrap: nowrap;
                            "
                            for="adults"
                            >Edad niños <span style="font-weight: 400 !important">- de 18 años</span></label
                          >
                        </div>

                        <div class="d-flex mb-4">
                          <div formArrayName="firstchildsage" *ngFor="let age of formArray(_form, 'firstchildsage'); let j = index">
                            <div *ngIf="j >= 0 && j <= 3">
                              <div [formGroupName]="j" class="p-0 ml-1" style="position: relative">
                                <select
                                  name="age"
                                  id="age"
                                  formControlName="age"
                                  [ngStyle]="{ 'margin-left': j > 0 ? '1em' : '' }"
                                  class="form-control custom-select-arrow"
                                  style="
                                    height: 35px !important;
                                    padding: 0 !important;
                                    width: 60px !important;
                                    font-family: &quot;Rubik&quot; !important;
                                    font-size: 14px !important;
                                    font-weight: 600 !important;
                                    text-align: left;
                                    padding-left: 13px !important;
                                    background-color: #FFFFFF !important;
                                    border-radius: 12px;
                                  "
                                >
                                  <ng-container *ngFor="let value of agesChildsArr()">
                                    <option value="{{ value }}">{{ value }}</option>
                                  </ng-container>
                                </select>
                                <span
                                  style="
                                    position: absolute;
                                    top: 42%;
                                    right: 0.7em;
                                    width: 0;
                                    height: 0;
                                    border-left: 4px solid transparent;
                                    border-right: 4px solid transparent;
                                  "
                                  [ngStyle]="{
                                    'border-top': '6px solid ' + getClientsSettingAppBooking?.clients_setting_global?.color_main_1
                                  }"
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="d-flex mb-4">
                          <div formArrayName="firstchildsage" *ngFor="let age of formArray(_form, 'firstchildsage'); let j = index">
                            <div *ngIf="j >= 4 && j <= 7">
                              <div [formGroupName]="j" class="p-0 ml-1" style="position: relative">
                                <select
                                  name="age"
                                  id="age"
                                  formControlName="age"
                                  [ngStyle]="{ 'margin-left': j > 4 ? '1em' : '' }"
                                  class="form-control custom-select-arrow"
                                  style="
                                    height: 35px !important;
                                    padding: 0 !important;
                                    width: 60px !important;
                                    text-align: center;
                                    font-family: &quot;Rubik&quot; !important;
                                    font-size: 14px !important;
                                    font-weight: 600 !important;
                                  "
                                >
                                  <ng-container *ngFor="let value of agesChildsArr()">
                                    <option value="{{ value }}">{{ value }}</option>
                                  </ng-container>
                                </select>
                                <span
                                  style="
                                    position: absolute;
                                    top: 42%;
                                    right: 0.7em;
                                    width: 0;
                                    height: 0;
                                    border-left: 4px solid transparent;
                                    border-right: 4px solid transparent;
                                  "
                                  [ngStyle]="{
                                    'border-top': '6px solid ' + getClientsSettingAppBooking?.clients_setting_global?.color_main_1
                                  }"
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="d-flex">
                          <div formArrayName="firstchildsage" *ngFor="let age of formArray(_form, 'firstchildsage'); let j = index">
                            <div *ngIf="j >= 8 && j <= 9">
                              <div [formGroupName]="j" class="p-0 ml-1" style="position: relative">
                                <select
                                  name="age"
                                  id="age"
                                  formControlName="age"
                                  [ngStyle]="{ 'margin-left': j === 9 ? '1em' : '' }"
                                  class="form-control custom-select-arrow"
                                  style="
                                    height: 35px !important;
                                    padding: 0 !important;
                                    width: 60px !important;
                                    font-family: &quot;Rubik&quot; !important;
                                    font-size: 14px !important;
                                    font-weight: 600 !important;
                                    text-align: left;
                                    padding-left: 13px !important;
                                    background-color: #FFFFFF !important;
                                    border-radius: 12px;
                                  "
                                >
                                  <ng-container *ngFor="let value of agesChildsArr()">
                                    <option value="{{ value }}">{{ value }}</option>
                                  </ng-container>
                                </select>
                                <span
                                  style="
                                    position: absolute;
                                    top: 42%;
                                    right: 0.7em;
                                    width: 0;
                                    height: 0;
                                    border-left: 4px solid transparent;
                                    border-right: 4px solid transparent;
                                  "
                                  [ngStyle]="{
                                    'border-top': '6px solid ' + getClientsSettingAppBooking?.clients_setting_global?.color_main_1
                                  }"
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex flex-row justify-content-end py-2">
                        <div class="py-2 justify-content-end">
                          <button
                            (click)="_confirm()"
                            [attr.aria-expanded]="!isCollapsed"
                            aria-controls="false"
                            class="badge btn-choice-confirm"
                            style="border: none; min-width: 145px; width: 100%; height: 36px"
                            type="button"
                            [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
                          >
                            Confirmar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group col-xg-2 col-lg-2 col-md-5 col-sm-5 px-1 mx-0" style="position: relative">
        <!-- <label for="passengers">&nbsp;</label> -->
        <input
          #datePickerInputFirst
          formControlName="firstArrivalDate"
          type="text"
          class="form-control input-search-box"
          id="departureDate"
          placeholder="Fecha de recogida"
          autocomplete="off"
          [ngStyle]="{ 'background-color': getStyleBackgroundReturn() }"
          bsDatepicker
          [minDate]="now"
          [bsConfig]="dpConfig"
          readonly
          [ngStyle]="{
            ':host tr.ng-star-inserted td.active.start-date.available::after': {
              background: getClientsSettingAppBooking?.clients_setting_global?.color_main_1
            },
            ':host tr.ng-star-inserted td.active.end-date.available::before': {
              background: getClientsSettingAppBooking?.clients_setting_global?.color_main_1
            }
          }"
        />
        <img
          src="../../../../../assets/icons/itinerary/calendar_13937514.svg"
          width="24px"
          style="position: absolute; right: 1em; top: 29%"
          (click)="datePickerInputFirst.click()"
          alt=""
        />
        <span
          class="help-block text-danger"
          *ngIf="_form.get('firstArrivalDate').touched && _form.get('firstArrivalDate').hasError('required')"
          >Este campo es obligatorio</span
        >
        <small
          class="error-label"
          *ngIf="
            _form.get('firstArrivalDate').touched &&
            _form.get('secondArrivalDate').value !== null &&
            _form.get('firstArrivalDate').hasError('invalidDate')
          "
        >
          * ¡El check-in debe ser una fecha anterior al check-out!
        </small>
      </div>

      <div class="form-group col-xg-2 col-lg-2 col-md-6 col-sm-6 px-1 mx-0 position-relative">
        <!-- NEW WHEEL TIME PICKER with input trigger -->
        <div class="wheel-picker-wrapper">
          <input
            type="text"
            class="form-control input-search-box"
            [value]="_form.get('firstTime').value || currentTime"
            [ngStyle]="{ 'background-color': getStyleBackgroundReturn() }"
            (click)="toggleTimePicker('firstTime', $event)"
            (input)="_onManualTimeInput($event, 'firstTime')"
            (blur)="_onTimeInputBlur('firstTime', $event)"
            placeholder="Hora pick up"
            [attr.data-time-input]="'firstTime'"
            inputmode="numeric"
            maxlength="5"
            pattern="^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$"
          />
          <img
            src="../../../../../assets/icons/search-box/reloj-traslado.svg"
            width="20px"
            style="position: absolute; right: 1em; top: 29%; cursor: pointer"
            (click)="toggleTimePicker('firstTime', $event)"
            alt=""
          />

          <!-- Dropdown with wheel picker -->
          <div class="wheel-picker-dropdown" *ngIf="activeTimePicker === 'firstTime'">
            <usb-wheel-time-picker
              [formControlName]="'firstTime'"
              [initialValue]="_form.get('firstTime').value || currentTime"
              [minuteStep]="1"
              (closed)="activeTimePicker = null"
            >
            </usb-wheel-time-picker>
          </div>
        </div>
      </div>

      <div class="form-group col-xg-2 col-lg-2 col-md-5 col-sm-5 px-1 mx-0 position-relative">
        <!-- <label for="passengers">&nbsp;</label> -->
        <span class="container-input-icon-cancel-date">
          <input
            #datePickerInputSecond
            formControlName="secondArrivalDate"
            type="text"
            class="form-control input-search-box input-arrival-date"
            id="departureDate"
            placeholder="Fecha de vuelta"
            autocomplete="off"
            [ngStyle]="{ 'background-color': getStyleBackgroundReturn() }"
            bsDatepicker
            [minDate]="_form.get('firstArrivalDate').value"
            [bsConfig]="dpConfig"
            (bsValueChange)="onDateChange($event)"
          />
          <img
            src="../../../../../assets/icons/itinerary/calendar_13937514.svg"
            width="24px"
            style="position: absolute; right: 1em; top: 29%"
            (click)="datePickerInputSecond.click()"
            alt=""
          />
          <span *ngIf="_form.get('secondArrivalDate').value !== null" class="square-class-secondArrival-date">
            <div class="container-square-secondArrival">
              <i
                class="bi bi-x x-icon-cancel"
                (mouseenter)="isHoveredCancelDate = true"
                (mouseleave)="isHoveredCancelDate = false"
                tooltip="Eliminar fecha y hora de salida"
                placement="bottom"
                (click)="resetSecondArrivalDate()"
              ></i>
            </div>
          </span>
          <span
            *ngIf="_form.get('secondArrivalDate').value === null"
            class="text-option-date"
            style="font-size: 12px !important"
            [ngClass]="hover ? 'hovered-class' : 'none-display'"
            [ngStyle]="{
              color: getClientsSettingAppBooking?.clients_setting_global?.color_main_1
            }"
            >Opcional</span
          >
        </span>
      </div>

      <div class="form-group col-xg-2 col-lg-2 col-md-6 col-sm-6 px-1 mx-0 position-relative">
        <!-- NEW WHEEL TIME PICKER with input trigger -->
        <div class="wheel-picker-wrapper">
          <input
            type="text"
            class="form-control input-search-box"
            [value]="_form.get('secondArrivalDate').value ? _form.get('secondTime').value || currentTime : ''"
            [ngStyle]="{ 'background-color': getStyleBackgroundReturn() }"
            (click)="toggleTimePicker('secondTime', $event)"
            (input)="_onManualTimeInput($event, 'secondTime')"
            (blur)="_onTimeInputBlur('secondTime', $event)"
            placeholder="Hora vuelta"
            [attr.data-time-input]="'secondTime'"
            inputmode="numeric"
            maxlength="5"
            pattern="^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$"
            [style.opacity]="_form.get('secondArrivalDate').value && _form.get('firstTime').value ? '1' : '0.5'"
            [style.cursor]="_form.get('secondArrivalDate').value && _form.get('firstTime').value ? 'pointer' : 'not-allowed'"
            [style.pointer-events]="_form.get('secondArrivalDate').value && _form.get('firstTime').value ? 'auto' : 'none'"
            style="padding-right: 35px"
          />
          <img
            src="../../../../../assets/icons/search-box/reloj-traslado.svg"
            width="20px"
            style="position: absolute; right: 1em; top: 29%; cursor: pointer"
            [style.cursor]="_form.get('secondArrivalDate').value && _form.get('firstTime').value ? 'pointer' : 'not-allowed'"
            [style.opacity]="_form.get('secondArrivalDate').value && _form.get('firstTime').value ? '1' : '0.5'"
            (click)="toggleTimePicker('secondTime', $event)"
            alt=""
          />

          <!-- Dropdown with wheel picker -->
          <div class="wheel-picker-dropdown" *ngIf="activeTimePicker === 'secondTime'">
            <usb-wheel-time-picker
              [formControlName]="'secondTime'"
              [initialValue]="_form.get('secondTime').value || (_form.get('secondArrivalDate').value ? currentTime : '')"
              [minuteStep]="1"
              [minTime]="isSecondTimeFloorActive() ? _form.get('firstTime').value : null"
              (closed)="activeTimePicker = null"
            >
            </usb-wheel-time-picker>
          </div>
        </div>
      </div>

      <div *ngIf="userService.itineraryActive" style="width: 16%">
        <!-- <label for="passengers">&nbsp;</label> -->
        <button
          class="btn btn-search-hotel d-flex justify-content-center align-items-center inp w-100"
          (click)="onSearchClick()"
          [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
          type="button"
        >
          <span>{{ getSearchButtonLabel() }}</span>
        </button>
      </div>
    </div>
  </form>
</div>

<!-- Template del componente -->
<div class="modal" [ngClass]="{ show: showModal }">
  <div class="modal-dialog">
    <div class="modal-content">
      <!-- Encabezado del modal -->
      <div class="modal-header">
        <h5 class="modal-title mt-2 text-black">{{ titleModal }}</h5>
        <!-- <button type="button" class="close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button> -->
      </div>
      <!-- Cuerpo del modal -->
      <div class="modal-body">
        <p class="mb-1 text-black">{{ messageModal }}</p>
      </div>
      <!-- Pie del modal -->
      <div class="d-flex flex-end justify-content-end mr-3 mb-4">
        <!-- <button type="button" class="btn btn-secondary" (click)="closeModal()">Cerrar</button> -->
        <button
          type="button"
          class="btn-confirm-modal rounded-pill"
          [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
          (click)="confirmAction()"
        >
          ACEPTAR
        </button>
      </div>
    </div>
  </div>
</div>
